import { Col } from 'antd';
import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, TwitterIcon, YoutubeIcon } from 'brand/Icons';
import useGlobalFooter from '../../hooks/useGlobalFooter';
import SubscribeForm from '../Form/SubscribeForm';
import getBreakpointView from 'utils/getBreakpointView';

import {
  BottomItem,
  Copyright,
  FooterBody,
  FooterBottom,
  FooterBottomMenu,
  FooterWrapper,
  IconItem,
  InnerContainer,
  Line,
  MenuItem,
  MenuItemLink,
  SocialIcons,
  STFooterLogo,
  Title,
  FormContainer,
} from './styles';

const WebsiteFooter = ({ anchorId, navigation }) => {
  const isMobile = getBreakpointView(['xs', 'sm']);
  const globalFooter = useGlobalFooter();
  const form = globalFooter?.form;

  if (!navigation) {
    navigation = globalFooter?.navigation?.navigation;
  }

  const mobileMenuColumItems = navigation.reduce(
    (columns, item, index) => {
      const left = index % 2 === 0;
      left ? columns.left.push(item) : columns.right.push(item);
      return columns;
    },
    { left: [], right: [] }
  );

  const currentYear = new Date().getFullYear();

  const footer = {
    footer: {
      copyright: `Copyright @${currentYear}`,
      body: [
        {
          title: 'Privacy Policy',
          linkTo: '/legal/privacy-policy',
        },
        {
          title: 'Security',
          linkTo:
            'https://assets.ctfassets.net/3q1a0w8cwuwf/4b41loSE3DZkIv11eUYfgY/9bffc02f86155cc5c7f591c5bb850a1e/coordinated-disclosure.pdf',
        },
        {
          title: 'Terms of Use',
          linkTo: '/legal/terms-of-use',
        },
        {
          title: "Don't Sell My Information",
          linkTo: '/legal/privacy-request',
        },
      ],
    },
  };

  const socialIcons = [
    {
      dataPosition: 'Footer - Facebook',
      url: 'https://www.facebook.com/ServiceTitan',
      icon: <FacebookIcon width="12" />,
    },
    {
      dataPosition: 'Footer - Instagram',
      url: 'https://www.instagram.com/servicetitan/',
      icon: <InstagramIcon width="20" />,
    },
    {
      dataPosition: 'Footer - Twitter',
      url: 'https://twitter.com/ServiceTitan',
      icon: <TwitterIcon width="20" />,
    },
    {
      dataPosition: 'Footer - LinkedIn',
      url: 'https://www.linkedin.com/company/servicetitan/',
      icon: <LinkedinIcon width="20" />,
    },
    {
      dataPosition: 'Footer - YouTube',
      url: 'https://www.youtube.com/user/servicetitan',
      icon: <YoutubeIcon fontSize="24px" />,
    },
  ];

  return (
    <FooterWrapper id={anchorId}>
      <InnerContainer>
        <STFooterLogo title="ServiceTitan" width="235" height="40" />
        <FooterBody gutter={{ xs: 20, md: 10 }}>
          {isMobile
            ? Object.keys(mobileMenuColumItems).map((column, index) => {
                return (
                  <Col xs={12} lg={6} key={`${index}--footerSection`}>
                    {mobileMenuColumItems[column].map((column, index) => {
                      return (
                        <div
                          className={`footer--mobile-menu-column footer-${column?.label?.toLowerCase()}-menu`}
                          key={`${index}--footerSection-mobile`}
                        >
                          <MenuLink item={column} />
                        </div>
                      );
                    })}
                  </Col>
                );
              })
            : navigation.map((section, index) => {
                return (
                  <Col
                    xs={12}
                    md={12}
                    lg={12}
                    key={`${index}--footerSection`}
                    className={`footer-${section?.label?.toLowerCase()}-menu`}
                  >
                    <MenuLink item={section} />
                  </Col>
                );
              })}
        </FooterBody>
        <Line />
        <FooterBottom>
          <FooterBottomMenu>
            <Copyright span={9}>{footer.footer.copyright}</Copyright>
            <div>
              {footer.footer.body.map((item, index) => {
                return (
                  <BottomItem href={item.linkTo} key={index} target="_blank">
                    {item.title}
                  </BottomItem>
                );
              })}
            </div>
          </FooterBottomMenu>
          <SocialIcons>
            {socialIcons.map((item, index) => {
              const { dataPosition, url, icon } = item;

              return (
                <IconItem
                  data-position={dataPosition}
                  href={url}
                  rel="noreferrer"
                  target="_blank"
                  key={`social-icon-${index}`}
                >
                  {icon}
                </IconItem>
              );
            })}
          </SocialIcons>
          <FormContainer>
            <SubscribeForm
              inlineMarketingForm={form}
              buttonType="secondary"
              notificationMessage="Thanks for subscribing!"
              shouldRedirect={false}
              formType="Email Capture"
              dataPosition="Footer"
            />
          </FormContainer>
        </FooterBottom>
      </InnerContainer>
    </FooterWrapper>
  );
};

export default WebsiteFooter;

const MenuLink = ({ item }) => {
  return (
    <>
      <Title>{item.label}</Title>
      {item.subNavigationElement.map((menuItem, index) => {
        if (
          item.label === 'Features' ||
          item.label === 'Industries' ||
          item.label === 'Resources'
        ) {
          return (
            <MenuItemLink
              data-position="Footer - Nav Element"
              href={`${menuItem.url}`}
              key={`${index}--subtitle`}
            >
              {menuItem.label}
            </MenuItemLink>
          );
        } else {
          return (
            <MenuItem
              data-position="Footer - Nav Element"
              key={index}
              href={`${menuItem.url}`}
              key={`${index}--subtitle`}
            >
              {menuItem.label}
            </MenuItem>
          );
        }
      })}
    </>
  );
};
